import { render, staticRenderFns } from "./wDateSelect.vue?vue&type=template&id=1842f34f&scoped=true&"
import script from "./wDateSelect.vue?vue&type=script&lang=js&"
export * from "./wDateSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1842f34f",
  null
  
)

export default component.exports